
import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Button from '../base/Button';
import { useAuth } from '../../hooks/useAuth';

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const isActive = (path: string) => location.pathname === path;

  const handleSignOut = async () => {
    await signOut();
    setShowUserMenu(false);
    navigate('/');
  };

  return (
    <header className="bg-white border-b-2 border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div 
            onClick={() => navigate('/')}
            className="flex items-center cursor-pointer"
          >
            <h1 className="text-2xl font-bold text-green-600" style={{ fontFamily: '"Pacifico", serif' }}>
              logo
            </h1>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a
              onClick={() => navigate('/')}
              className={`cursor-pointer ${
                isActive('/') ? 'text-green-600 font-semibold' : 'text-gray-700 hover:text-green-600'
              }`}
            >
              Home
            </a>
            <a
              onClick={() => navigate('/categories')}
              className={`cursor-pointer ${
                isActive('/categories') ? 'text-green-600 font-semibold' : 'text-gray-700 hover:text-green-600'
              }`}
            >
              Categories
            </a>
            <a
              onClick={() => navigate('/how-it-works')}
              className={`cursor-pointer ${
                isActive('/how-it-works') ? 'text-green-600 font-semibold' : 'text-gray-700 hover:text-green-600'
              }`}
            >
              How It Works
            </a>
            <a
              onClick={() => navigate('/help')}
              className={`cursor-pointer ${
                isActive('/help') ? 'text-green-600 font-semibold' : 'text-gray-700 hover:text-green-600'
              }`}
            >
              Help
            </a>
          </nav>

          {/* Actions */}
          <div className="flex items-center space-x-4">
            {user ? (
              <div className="relative">
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  className="flex items-center space-x-2 cursor-pointer hover:text-green-600"
                >
                  <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center text-white font-semibold">
                    {user.email?.charAt(0).toUpperCase()}
                  </div>
                  <i className="ri-arrow-down-s-line"></i>
                </button>

                {showUserMenu && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                    <button
                      onClick={() => {
                        navigate('/dashboard');
                        setShowUserMenu(false);
                      }}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                    >
                      <i className="ri-dashboard-line mr-2"></i>
                      Dashboard
                    </button>
                    <button
                      onClick={() => {
                        navigate('/post-ad');
                        setShowUserMenu(false);
                      }}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                    >
                      <i className="ri-add-circle-line mr-2"></i>
                      Post Ad
                    </button>
                    <div className="border-t border-gray-200 my-2"></div>
                    <button
                      onClick={handleSignOut}
                      className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 cursor-pointer"
                    >
                      <i className="ri-logout-box-line mr-2"></i>
                      Sign Out
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <>
                <Button 
                  variant="outline" 
                  size="sm"
                  onClick={() => navigate('/signin')}
                >
                  Sign In
                </Button>
                <Button 
                  variant="primary" 
                  size="sm"
                  onClick={() => navigate('/post-ad')}
                >
                  Post Ad
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
